import React from "react";
import { useParams } from "react-router-dom";
import {
   ArrowLeftOutlined,
   ArrowRightOutlined,
   LoadingOutlined,
   SendOutlined
} from "@ant-design/icons";
import { SaveDraftIcon } from "../../../../../../assets/icons/SaveDraftIcon";
import { SeeDraftsIcon } from "../../../../../../assets/icons/SeeDraftsIcon";
import { content } from "./content";

const SendIcon = () => <SendOutlined rotate={-45} className="tr-actions__send-icon" />;

/**
 * The card's footer: the same draft and submit handlers PreviewActions receives, plus step
 * navigation. `showSurveyActions` mirrors the conditions Preview uses to show PreviewActions, so
 * an author previewing a draft survey can still step through it but cannot submit.
 */
const TetoriRozeActions = ({
   canGoBack,
   isLastStep,
   onBack,
   onNext,
   onFinish,
   showSurveyActions,
   seeDraftsProps,
   saveDraftProps,
   submitProps,
   hideSubmitButton
}) => {
   const { uuid } = useParams();
   const { actions } = content;
   const showDraftActions = showSurveyActions && uuid !== "multi-use-kiosk";
   const showFinish = isLastStep && showSurveyActions && !hideSubmitButton;
   const isSubmitting = Boolean(submitProps?.loading);

   return (
      <div className="tr-actions hide-on-print">
         {canGoBack && (
            <button type="button" className="tr-btn tr-btn--outline" onClick={onBack}>
               <ArrowLeftOutlined />
               <span>{actions.back}</span>
            </button>
         )}

         {showDraftActions && (
            <>
               <button
                  type="button"
                  className="tr-btn tr-btn--outline"
                  onClick={seeDraftsProps?.onClick}
               >
                  <SeeDraftsIcon />
                  <span>{actions.seeDrafts}</span>
               </button>
               <button
                  type="button"
                  className="tr-btn tr-btn--outline"
                  onClick={saveDraftProps?.onClick}
               >
                  <SaveDraftIcon />
                  <span>{actions.saveDraft}</span>
               </button>
            </>
         )}

         {!isLastStep && (
            <button
               type="button"
               className="tr-btn tr-btn--primary tr-actions__primary"
               onClick={onNext}
            >
               <SendIcon />
               <span>{actions.next}</span>
               <ArrowRightOutlined />
            </button>
         )}

         {showFinish && (
            <button
               type="button"
               className="tr-btn tr-btn--primary tr-actions__primary"
               onClick={onFinish}
               disabled={isSubmitting}
               aria-busy={isSubmitting}
            >
               {isSubmitting ? <LoadingOutlined /> : <SendIcon />}
               <span>{isSubmitting ? actions.processing : actions.finish}</span>
            </button>
         )}
      </div>
   );
};

export default TetoriRozeActions;
